import { forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import type { InjectionToken, Type } from '@angular/core';
import type { ControlValueAccessor } from '@angular/forms';

interface ValueAccessorProvider<T> { provide: InjectionToken<ReadonlyArray<ControlValueAccessor>>; useExisting: Type<T>; multi: boolean }

export const ValueAccessorProviderFactory = <T extends ControlValueAccessor>(type: Type<T>): ValueAccessorProvider<T> => ({
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef((): Type<T> => type),
  multi: true
});
